import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Calendar, X } from "lucide-react";
import DatePickerBase from "./DatePickerBase";
import { ensureISODate } from "../../../utils/dateUtils";
import {
  SHEET_ANIMATION,
  BACKDROP_ANIMATION
} from "../../../mobile/FilterSheets/sheetAnimationConfig";

const DatePickerSheet = ({
  isOpen,
  onClose,
  selectedDate,
  onDateSelect,
  title = "Select Date"
}) => {
  const normalizedValue = ensureISODate(selectedDate);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            {...BACKDROP_ANIMATION}
            onClick={onClose}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50"
          />

          <motion.div
            {...SHEET_ANIMATION}
            className="fixed bottom-0 left-0 right-0 bg-gray-900 rounded-t-3xl z-50 max-h-[85vh] overflow-hidden"
          >
            <div className="flex justify-center pt-2">
              <div className="w-10 h-1 bg-white/20 rounded-full" />
            </div>

            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
              <h3 className="text-lg font-semibold text-white flex items-center gap-2">
                <Calendar size={20} className="text-emerald-400" />
                {title}
              </h3>
              <button
                type="button"
                onClick={onClose}
                className="p-2 rounded-full hover:bg-white/10 transition-colors"
                aria-label="Close date picker"
              >
                <X size={20} className="text-white/70" />
              </button>
            </div>

            <div className="overflow-y-auto max-h-[60vh]">
              <DatePickerBase
                value={normalizedValue}
                onChange={onDateSelect}
                onClose={onClose}
                closeOnSelect
              />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default DatePickerSheet;

